import { render, staticRenderFns } from "./ReferralReport.vue?vue&type=template&id=72406f9e&"
import script from "./ReferralReport.vue?vue&type=script&lang=js&"
export * from "./ReferralReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports